var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","justify-center":""}},[_c('h1',[_vm._v("Add New Practice View")])])}
var staticRenderFns = []

export { render, staticRenderFns }